module.exports = (__webpack_require__("hk27"))("yLV6");